export default {
  "content": "<path d=\"M18 14h-2V8h2v6z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.794 4.978c3.067-.794 6.543-1.746 10.148.034a1 1 0 01.558.897v12a1.001 1.001 0 01-1.442.896c-2.843-1.403-5.584-.713-8.763.11-3.08.797-6.58 1.719-10.242-.112a1.001 1.001 0 01-.553-.894v-12a1 1 0 011.447-.895c2.904 1.452 5.681.783 8.847-.036zM20.5 6.556c-2.646-1.063-5.234-.41-8.205.359-2.673.691-5.66 1.475-8.795.476v9.874c2.706 1.115 5.33.48 8.294-.287 2.656-.687 5.618-1.492 8.706-.54V6.556z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};